import styled, { css } from 'styled-components';
import FormFieldInput from '@anwb/form-field-input';
import { STATIC_BASE_URL, pxToRem } from '@anwb/style-utilities';
const LICENSE_PLATE_HEIGHT = '56';
const LICENSE_PLATE_WIDTH = '12.4rem';
export const FormFieldLicensePlateInputStyles = ({ theme }) => css `
	&& {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-left: ${pxToRem(Number(theme.spacing['500']))};
		width: ${LICENSE_PLATE_WIDTH};
		height: ${pxToRem(LICENSE_PLATE_HEIGHT)};
		border-radius: ${pxToRem(Number(theme.borderRadius.m))};
		border: ${pxToRem(Number(theme.borderWidth[2]))} solid ${theme.colors.base.licensePlate};
		background-color: ${theme.colors.accent.bgFormFieldLicensePlate};
		background-image: url(${`${STATIC_BASE_URL}/poncho/license-plate/images/input-text-license-plate.svg`});
		background-repeat: no-repeat;
		background-position: 0 40%;
		background-size: 2.2rem;
		color: ${theme.colors.dark.textLicenseplate};
		text-align: center;
		text-transform: uppercase;

		&:hover,
		&:active,
		&:focus {
			border: ${pxToRem(Number(theme.borderWidth[2]))} solid ${theme.colors.base.licensePlate};
		}

		&[aria-invalid='true'] {
			:not(:disabled) {
				border: ${pxToRem(Number(theme.borderWidth[2]))} solid ${theme.colors.error.borderFormField};
			}
		}

		// Added to overwrite the errorstyling of formfieldinput (namely the icon that show up on error) This needs to be fixed prettier if this components is being rebuild of refactored
		~ div > span {
			display: none;
		}
	}
`;
export const FormFieldLicensePlateInput = styled(FormFieldInput) `
	${FormFieldLicensePlateInputStyles}
`;
//# sourceMappingURL=license-plate-input.styled.js.map